import { useEffect, useState } from "react";
import { MonitorFaturamentoService } from "../../../../services";
import { responseErros } from "../../../../utils";
import MonitorFatCard from "./monitor-fat-card.view";
import MonitorFatRankingBarra from "./monitor-fat-ranking-barra.view";

const monitorFaturamentoService = new MonitorFaturamentoService();

function MonitorFatRankingVendedoresProdutos({ filtrosBody }) {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    buscarVendedoresProdutos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtrosBody]);

  async function buscarVendedoresProdutos() {
    setLoading(true);
    const result = await monitorFaturamentoService.rankingVendedoresProdutos(
      filtrosBody,
    );
    if (!result.isAxiosError) {
      setRows(result.data || []);
    } else {
      responseErros(result);
    }
    setLoading(false);
  }

  const itens = rows.map((r) => ({
    key: r.vendedorId,
    label: r.nome,
    valor: r.valor,
  }));

  return (
    <MonitorFatCard
      titulo="Top 5 Vendedores de Produtos"
      icone="ph-medal"
      loading={loading}
      alturaSkeleton={160}
    >
      <MonitorFatRankingBarra itens={itens} corBarra="#1976d2" />
    </MonitorFatCard>
  );
}

export default MonitorFatRankingVendedoresProdutos;
